/* istanbul ignore file */
import ErrorBoundary from '@ms/yammer-libs-error-boundary';
import type { FC } from 'react';
import React from 'react';

import AppError from '../AppError';

import App from './App';

const AppBoundary: FC = () => (
  <ErrorBoundary ErrorComponent={AppError} name="App">
    <App />
  </ErrorBoundary>
);

export default AppBoundary;
